import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";
import { fget } from "../../../API/callsApi";
import useStyles from "../LicensesOverview/LicensesOverview.styles";
import CommonLoader from "../../ReusableComponents/CommonLoader/CommonLoader";
import NoDataFound from "../../ReusableComponents/NoDataFound/NoDataFound";
import CancelledLicenseTableItem from "./CancelledLicenseTableItem";
import CustomPagination from "../../ReusableComponents/CustomPagination/CustomPagination";

const CancelledLicensesTable = ({ licenseSearchValue }) => {
  const classes = useStyles();
  const params = useParams();
  const [cancelledLicense, setCancelledLicense] = useState({
    count: 0,
    data: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  const getLicenses = async () => {
    if (params.sid) {
      setIsLoading(true);
      try {
        const res = await fget({
          url: `/admin/license/?org=${params.orgId}&service=${params.sid}&status=cancelled&page=${currentPage}`,
        });
        setCancelledLicense({
          count: res.data.count,
          data: res.data.results,
        });
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    getLicenses();
  }, [params.sid, updateOnPageChange]);

  return (
    <>
      <TableContainer style={{ height: "7%", overflow: "hidden" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                className={`${classes.tableRowHeadService} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                License ID
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.tableRowHeadService} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                License Type
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.tableRowHeadService} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                User
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.tableRowHeadService} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                Subscribed on
              </TableCell>
              <TableCell
                align="center"
                className={`${classes.tableRowHeadService} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                Expired on
              </TableCell>
              <TableCell
                align="right"
                className={`${classes.tableRowHeadService} ${classes.tableRowCellsColor} ${classes.tableRowBorder}`}
              >
                <span style={{ marginRight: "40px" }}>Action</span>
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
      <Box
        style={{
          height: cancelledLicense.count > 50 ? "81%" : "84%",
          overflowY: "auto",
          border: "1px solid black",
          borderRadius: "5px",
        }}
      >
        <TableContainer>
          <Table aria-label="simple table">
            <TableBody style={{ height: "100%" }}>
              {isLoading ? (
                <div className={classes.commonLoader}>
                  <CommonLoader />
                </div>
              ) : cancelledLicense && cancelledLicense.data.length > 0 ? (
                cancelledLicense.data
                  ?.filter((search) => {
                    if (licenseSearchValue === undefined) {
                      return search;
                    } else if (licenseSearchValue === "") {
                      return search;
                    } else if (
                      search.license_number
                        .toLowerCase()
                        .includes(licenseSearchValue.toLowerCase())
                    ) {
                      return search;
                    } else if (
                      search.user &&
                      search.user.first_name
                        .toLowerCase()
                        .includes(licenseSearchValue.toLowerCase())
                    ) {
                      return search;
                    } else if (
                      search.user &&
                      search.user.last_name
                        .toLowerCase()
                        .includes(licenseSearchValue.toLowerCase())
                    ) {
                      return search;
                    }
                    return null;
                  })
                  .map((eachLicense) => {
                    return (
                      <CancelledLicenseTableItem
                        key={eachLicense.id}
                        eachLicense={eachLicense}
                      />
                    );
                  })
              ) : (
                <NoDataFound />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {cancelledLicense.count > 50 && (
        <footer style={{ width: "100%", position: "relative" }}>
          <CustomPagination
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            totalItem={cancelledLicense?.count}
            totalPage={
              cancelledLicense ? Math.ceil(cancelledLicense?.count / 50) : 0
            }
            type="Cancelled Licenses"
          />
        </footer>
      )}
    </>
  );
};

export default CancelledLicensesTable;
